import { useConfirm } from './useConfirm'

/**
 * Muestra una alerta informativa (sin botón cancelar).
 * Reemplaza: Swal.fire(title, text, icon)
 *
 * Uso:
 *   await useAlert().alert({ title: 'Guardado', text: 'Los datos fueron guardados.', icon: 'success' })
 */
export function useAlert() {
  const { confirm } = useConfirm()

  function alert(options = {}) {
    return confirm({
      ...options,
      showCancel: false,
      confirmText: options.confirmText ?? 'Aceptar',
    })
  }

  return { alert }
}
